"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbagssm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbagssm` : '') + (description ? ` desc-brandedbagssm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbagssm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbagssm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.69.57a.7.7 0 0 1 .7-.57h10c.36 0 .67.26.7.6L20 17.26c.05.4-.28.74-.71.74H4.78c-.44 0-.78-.36-.72-.76L6.7.57Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.3 1.5c0-.28.25-.5.57-.5h4.86c.32 0 .57.22.57.5s-.25.5-.57.5H9.87c-.32 0-.57-.22-.57-.5Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.84 6.72a1 1 0 0 1 .98-.84h6.4a1 1 0 0 1 .97.82l1.95 10.11a1 1 0 0 1-.98 1.19H1.18a1 1 0 0 1-1-1.16L1.85 6.72Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "3.82397",
    y: "6.93568",
    width: "4.07898",
    height: "0.661111",
    rx: "0.330555",
    fill: "white"
  }));
};
var _default = exports.default = brandedbagssm;